import React from 'react';
import {
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TelegramShareButton,
  TelegramIcon,
  TwitterShareButton,
  TwitterIcon,
} from 'react-share';

const SocialShare = ({ url, ...rest }) => {
  return (
    <div className="my-4" {...rest}>
      <FacebookShareButton className="mx-1" url={url}>
        <FacebookIcon borderRadius="50%" size={30} />
      </FacebookShareButton>
      <LinkedinShareButton className="mx-1" url={url}>
        <LinkedinIcon borderRadius="50%" size={30} />
      </LinkedinShareButton>
      <TelegramShareButton className="mx-1" url={url}>
        <TelegramIcon borderRadius="50%" size={30} />
      </TelegramShareButton>
      <TwitterShareButton className="mx-1" url={url}>
        <TwitterIcon borderRadius="50%" size={30} />
      </TwitterShareButton>
    </div>
  );
};

export default SocialShare;
